module.exports = __webpack_public_path__ + "static/img/wenzi.a5792f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankPC/wenzi.png
// module id = DCGp
// module chunks = 69